export const English = {

  errorMessage: {
    inputErrorMessage: 'Please select or input a valid value',
    mandatoryFieldsToastErrorMessage: 'Please fill all mandatory fields!',
    verifyAddressError: 'Please verify the address',
    smartyStreetMsg: {
      errorMsg: "Please ensure that you have entered a valid address. We are unable to verify the address entered; however, if the address you provided is correct, please proceed.",
      sucessMsg: "Address verified"
    },
  },
  SignUp: {},
  Login: {
    mainContent: "A few more clicks to sign in to your account.",
    subContent: "Manage All Your Applications & Cases In One Place",
    signIn: "Sign In",
    rememberMe: "Remember me",
    forgotPassword: "Forgot Password?",
    login: "Login",
    register: "Register",
    agree: "By signin up, you agree to our",
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    needHelp: "Need Help?",
    tooltip0001: "Legal Agreement regarding the Terms to use our portal.",
    tooltip0002: "Terms of Use",
    tooltip0101:
      "What does Patient Advocate Foundation do with your information?",
    tooltip0102: "Privacy and Compliance",
    tooltip0201:
      " View the operational disclaimer and important details for each of PAF’s patient divisions.",
    tooltip0202: "Program Disclaimers",
    tooltip0301: "Information to help you navigate the Patient Partner Portal.",
    tooltip0302: "Portal Guide",
  },
  Sidemenu: {
    applyfor: "Apply for Services",
    applications: "View All Applications/Cases",
    cases: "Request Case Management Assistance",
    educationResource: "Search the PAF Education Resource Library",
    claims: "View/Submit TotalAssist Claims",
    financialResource: "Search National Financial Resource Directory",
    reports: "Reports",
    logout: "Logout",
  },
  Topbar: {
    heading: "Sylvester Stallone",
    subHeading: "DevOps Engineer",
    profile: "Profile",
    addAccount: "Add Account",
    resetPassword: "Reset Password ",
    help: "Help",
    logout: "Logout",
  },
  ApplicationCard: {
    viewApplication: "View Application",
    patientBalance: "Balance :",
    fund: "Fund :",
    lookBackDate: "Lookback date :",
    approvalDate: "Eff date :",
    expiryDate: "Expiry :",
  },
  CaseCard: {
    viewCase: "View Case",
    program: "Program",
    phoneNumber: "Phone Number",
    createdDate: "Created date",
    approvalDate: "Approval date",
    expiryDate: "Expiry date",
  },
  Dashboard: {
    recentlyCreatedApplication: "Recently Created Application",
    casesChart: {
      cases: "Cases",
      inProgress: "In Progress",
      closed: "Closed",
      new: "New",
      viewAll: "View All",
    },
    applicationsChart: {
      application: "Application",
      activeUsers: "Active Users",
      approved: "Approved",
      expired: "Expired",
      pending: "Pending",
      viewAll: "View All",
    },
    resources: {
      financialResource: "Financial Resource",
      clickHere: "Click here",
      educationalResource: "Education Resource",
      resourcesdirectory: {
        searchHeader: "National Financial Resource Directory",
        doYouHaveInsurance: "Do you have insurance?",
        ageRange: "Age Range:",
        residentialState: "Residential State:",
        medicalDiagnosis: "Medical Diagnosis:",
        assistanceTypeNeeded: "Assistance Type Needed:",
        search: "Search",
        printResources: "Print Resources",
        emailResources: "Email Resources",
        email: "Email",
        sendEmail: "Send Email",
        resetFilter: "Reset Filter",
        selectAll: "Select All",
        deSelectAll: "Deselect All",
        inputErrorMessage: 'Please select or input a valid value',
        mandatoryToastError: "Please fill all mandatory fields!",
        assistanceType: "Assistance Type",
        resourceType: 'Resource Type',
        metropolitanCityArea: "Metropolitan City Area",
        genderAndIdentity: "Gender and Identity",
        disabilityStatus: "Disability Status",
        armedForcesStatus: "Armed Forces Status",
        resourceToPrint: "Select at least one resource to print"
      }
    },
    requiredActions: {
      heading: "Required Actions",
      showAll: "Show all",
      program: "PROGRAM",
      ref: "Remaining Task",
      serviceType: "Program",
      patient: "Patient",
      action: "Complete Task",
      description: "DESCRIPTION",
      patientName: "PATIENT NAME",
      status: "STATUS",
      actions: "ACTIONS",
      view: "view",
    },
  },
  Messages: {
    portalMessage: "Portal Message",
    recentActivities: {
      heading: " Recent Activities",
      showMore: "Show More",
    },
  },
  Applications: {
    heading: "List of all applications and cases in your account",
    SEARCH_PATIENT_NAME: "SEARCH PATIENT NAME",
    Reset_Filter: "Reset Filter",
    Search_and_Filter: "Search and Filter",
    FAF: "FAF",
    CPR: "CPR",
    ALL: "ALL",
    SEARCH_BY_STATUS: "SEARCH BY STATUS",
    SEARCH_BY_FUND: "SEARCH BY FUND",
    SEARCH_BY_DOB: "SEARCH BY DOB",
    SEARCH_BY_SSN: "SEARCH BY SSN",
    SEARCH_BY_ALIEN: "SEARCH BY ALIEN",
    Expiry: "Expiry",
    Actions_Required: "Actions Required",
    App_Closure: "App Closure",
    Apply_Filter: "Apply Filter",
  },
  Cases: {
    heading: "List of all cases in your account",
  },
  PatientSearch: {
    createPatient: {
      createPatientHeading: 'CREATE PATIENT',
      addresInfo: 'ADDRESS INFORMATION',
      communicationInfo: 'COMMUNICATION INFORMATION',
      addressLine1: 'Address Line 1',
      addressLine2: 'Address Line 2',
      city: 'City',
      state: 'State',
      zipCode: "Zip Code",
      phoneNumber: 'Phone Number',
      email: 'E-Mail',
      verifyAddress: 'Verify Address',
      cancelBtn: 'Cancel',
      submitBtn: 'Submit'
    },
    searchPatient: {
      heading: "APPLY FOR SERVICES",
      subHeading:
        "To start off, please select the program  & enter the required patient details.",
      program: "Program",
      patientDetails: "PATIENT SEARCH",
      firstName: "First Name",
      lastName: "Last Name",
      contactID: "Contact ID",
      SSN: "SSN",
      AlienNumber: "Alien Number",
      DOB: "Date of birth",
      search: "Search",
    },
    patientDetails: {
      heading: "Patient Details",
      applyforheading: 'APPLY FOR SPECIFIC PROGRAM',
      selectProgram: 'Select Program',
      createApp: 'Apply',
      createCase: 'Apply',
      contactID: "Contact ID",
      SSN: "SSN",
      DOB: "Date of birth",
      AlienNumber: "Alien Number",
      contactDetails: "Contact Details",
    },
    patientCard: {
      program: 'PROGRAM',
      application: "Application",
      claims: "Claims",
      applicationID: "ID",
      fund: "FUND",
      status: "STATUS",
      actions: "ACTIONS",
      view: "view",
    },
  },
  Claims: {
    heading: " List of all claims in your account",
    createExpenditure: "Submit Claim",
    program: "Program",
    claimID: "CLAIM ID",
    patientName: "PATIENT NAME",
    status: "STATUS",
    actions: "ACTIONS",
    view: "view",
  },
  CreateApp: {
    createApplication: "Create Application",
  },
  PreQual: {
    heading: "PreQualification",
    subHeading: "To start off, Enter the required patient details.",
    addressInformation: {
      heading: "ADDRESS INFORMATION",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "City",
      state: "State",
      zipcode: "Zipcode",
      verifyAddress: "Verify Address",
    },
    medicalInformation: {
      heading: "MEDICAL INFORMATION",
      diagnosis: "Diagnosis",
      insurance: "Does the patient have medical and/or prescription insurance",
      insuranceType: "Insurance Type",
      fund: "Fund",
    },
    cancel: "Cancel",
    submit: "Submit",
  },
  PreQualDenial: {
    heading: "PreQual Denial Reason",
    reason: "Patient is not eligible to apply for",
    closeBtn: "Close",
    retain: "Please retain this information for your records. If you feel you received this message in error or your circumstances change in the future, please feel free to contact the program at 866-512-3861 so that a program specialist can assist you."
  },
  AppintakeCard: {
    newPatient: "New Patient",
    DOB: "Date of birth",
    SSNorAlienNumber: "SSN or Alien Number",
    phoneNumber: "Phone Number",
    email: "Email",
  },
  Appintake: {
    personalInformation: {
      addressInformation: {
        heading: "ADDRESS INFORMATION ",
        addressType: "Address Type",
        addressLine1: "Address Line 1",
        addressLine2: "Address Line 2",
        city: "City",
        state: "State",
        zipcode: "Zipcode",
      },
      contactDetails: {
        heading: "CONTACT INFORMATION",
        contactBy:
          "How would you like to be contacted? All program letters and communications will be sent to the patient based on your selection",
        preferedLanguage: "Prefered Language",
        email: "Email",
        emailType: "Email Type",
        emailOwner: "Email Owner",
        phoneType: "Phone Type",
        phoneNumber: "Phone Number",
        contactSequence: "Contact Sequence",
      },
      guardianInfo: {
        heading: "Guardian Information",
        guardianFirstName: "Guardian First Name",
        guardianLastName: "Guardian Last Name",
        suffix: "Suffix",
        guardianDOB: "Guardian Date of Birth",
        guardianSSN: "Guardian SSN",
        guardianAlien: "Guardian Alien No",
        relationshipToPatient: "Relationship to Patient",
        guardianEmployment: "Guardian Employment Status",
        guardianEmail: "Guardian Email",
        emailType: "Email Type",
        sameAddress: "Same Address as Patient?",
        samePhoneNumber: "Same Phone Number as Patient?",
        addressLine1: "Address Line 1",
        addressLine2: "Address Line 2",
        city: "City",
        state: "State",
        zipcode: "ZipCode",
        verifyAddress: "Verify Address",
        phoneType: "Phone Type",
        phoneNumber: "Phone Number",
      },
      additionalInformation: {
        heading: "ADDITIONAL INFORMATION",
        gender: "Gender",
        employementStatus: "Employment status",
        veteran: "Veteran",
        maritalStatus: "Marital status",
        householdSize: "Household size",
      },
      race: {
        heading: "Race(Select all that applies)",
        americanIndian: "American Indian/Alaskan Native",
        asian: "Asian",
        africanAmerican: "Black/African American",
        white: "White",
        pacificIslander: "Native Hawaiian/Pacific Islander",
        preferNotToDisclose: "Prefer not to disclose",
        Origin: "Hispanic/Latino/Spanish Origin",
        otherSpecify: "If Other, Please Specify"
      },
      applicantInformation: {
        heading: "APPLICANT INFORMATION",
        relationshipToPatient: "Relationship to Patient",
        firstName: "First Name",
        lastName: "Last Name",
        phoneNumber: "Phone Number"
      },
      referalInformation: {
        heading: "REFERAL INFORMATION",
        referredBy: "How was the patient referred to the program?",
      },
      healthCare: {
        firstName: "First Name",
        lastName: "Last Name",
        facilityPractice: "Facility/Practice Name",
        position: "Position/Title",
        addressLine1: "Address Line 1",
        addressLine2: "Address Line 2",
        city: "City",
        state: "State",
        zipcode: "ZipCode",
        phoneNumber: "Phone Number",
        email: "Email Address",
        emailType: "Email Type",
        facilityName: "Name of Facility",
        sameAsSwitch: "Is person applying on behalf of the Patient the same as the referring Healthcare Professional?"
      },
      ePayment: {
        heading: "METHOD OF PAYMENT",
        method: "Preferred Method Of Payment"
      }
    },
    authorizedPerson: {
      authorizedPersonInfo:
        " Patient information will only be discussed or released as required to assist in the determination and delivery of services from the Program to which the patient is applying. Any requests to share information with anyone other than the patient’s medical team, can only be done with the express consent of the patient. Please list all individuals (other than patient’s medical care team) that the patient has authorized to contact the program on their behalf. (Examples include, but are not limited to, spouse, partner, parent, child, sibling, social worker, case manager, friend etc.).",
        "authorizedPersonInfoCPR" : "Patient information will only be discussed or released as required to assist in the determination and delivery of services from the Program to which the patient is applying. Any requests or sharing of information with anyone other than the medical team, can only be done with the expressed consent of the patient. Please list all individuals (other than patient’s medical care team) that the patient has authorized to contact the program on their behalf. (Examples of such individuals can include case managers (not part of the medical care team), spouse, children, friends, etc.).",
      authorizedPersonQuestion:
        "Are there any authorized users able to speak on behalf of the patient?",
      firstName: "First Name",
      lastName: "Last Name",
      suffix: "Suffix",
      relationshipToPatient: "Relationship to Patient",
      sameAddress: "Same Address as Patient?",
      samePhoneNumber: "Same Phone Number as Patient?",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "City",
      state: "State",
      zipcode: "Zip Code",
      verifyAddress: "Verify Address",
      phoneType: "Phone Type",
      phoneNumber: "Phone Number",
      addOneMore: "ADD ONE MORE",
      isCopySwitch: "Would the patient like program communications sent to this authorized person via email?",
      email: "Email Address"
    },
    insurance: {
      primaryInsurancecarrier: "PRIMARY INSURANCE CARRIER",
      insuranceType: "Insurance Type",
      healthInsurance: "Does the patient have health insurance?",
      policyDetails: {
        heading: " POLICY DETAILS",
        primaryInsurance: "Primary Insurance",
        planType: "Plan Type",
        policyID: "Policy ID",
        insuranceType: "Insurance Type",
        telephoneNumber: "Telephone Number",
      },
      subscriberDetails: {
        heading: " SUBSCRIBER DETAILS",
        subscriberName: "Subscriber Name",
        groupNumber: "Group Number",
        DOB: "Subscriber DOB",
      },
      insuranceInformation: {
        heading: " INSURANCE INFO",
        medicareSupplement: "Does the patient have a medicare supplement?",
        secondaryInsurance: "Does the patient have secondary insurance?",
        medicarePart: "Do you have medicare Part D?",
        secondaryInsuranceCarrier: "Name of secondary insurance carrier",
        isSecondaryInsurance: "Secondary Insurance",
        insuranceCarrier: "Name Of Insurance Carrier"
      },
    },
    medical: {
      searchTreatingPhysician: "Search Your Treating Physician",
      searchTreatingPhysicianCPR: "Search Your Treating Provider",
      stateandCity:
        "Please enter State and City to search for your treating physician.",
        stateandCityCPR:
        "Please enter State and City to search for your treating provider.",
      additionalInfo:
        "Enter additional information to improve your search results.",
      state: "State",
      city: "City",
      firstName: "First Name",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      lastName: "Last Name",
      addressType: "Address Type",
      zipcode: "Zip Code",
      reset: "Reset",
      search: "Search",
      address: "Address",
      phoneNumber: "Phone Number",
      extension: "Extension",
      email: "Email",
      fax: "Fax",
      suite: "Suite#",
      officeContactName: "Office Contact Name",
      officeContactEmail: "Office Contact Email Address",
      primaryDiagnosis: "Patient's Primary Diagnosis",
      selectYourTreatingPhysicianCantent: "The following physicians match your search criteria. Please select your treating physician from the list below by clicking on the appropriate selection. Once you have selected the treating physician it will be highlighted in blue. If you need to make a change in your selection, simply click on the correct physician. If you do not see your treating physician on the list below,",
      selectYourTreatingPhysicianCantentCPR: "The following providers match your search criteria. Please select your treating provider from the list below by clicking on the appropriate selection. Once you have selected the treating provider it will be highlighted in blue. If you need to make a change in your selection, simply click on the correct provider. If you do not see your treating provider on the list below,",
      DOD: "Date Of Diagnosis",
      actualDOD: "Scheduled/Actual Date of Test",
      verifyAddressError:
        "Please ensure that you have entered a valid address. We are unable to verify the address entered; however, if the address you provided is correct, please proceed.",
      verifyAddressSucces: "Address Verified.",
      verifyAdreesBtn: "Verify Address",
      selectYourTreatingPhysician: "Select Your Treating Physician",
      selectTreatingPhysician: "Select Treating Physician",
      selectYourTreatingPhysicianCPR: "Select Your Treating Provider",
      selectTreatingPhysicianCPR: "Select Treating Provider",
      toastError: "Please fill all mandatory fields!",
      clickHeretoAdd: "click here to add",
      addYourTreatingPhysician: "Add Your Treating Physician",
      addYourTreatingPhysicianCPR: "Add Your Treating Provider",
      youCanAlsoTryToSearch: "You can also try to search",
      clickHereToSearch: "Click Here to search",
      homozygousFamilial: " Homozygous Familial",
      hypercholesterolemia: " Hypercholesterolemia",
      couldNotFindYourPhysician: "Couldn't find your physician?",
      pleaseEnterStateAndCityToSearchYourTP: "Please Enter State and City to Search Your Treating Physician",
      couldNotFindYourPhysicianCPR: "Couldn't find your Provider?",
      pleaseEnterStateAndCityToSearchYourTPCPR: "Please Enter State and City to Search Your Treating Provider",
    },
  },
  Claimintake: {
    payableTo: {
      heading: "Payable To",
      name: "Name",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "City",
      state: "State",
      zipcode: "ZIP Code",
      verifyAddress: "Verify Address",
    },
    documents: {
      dragAndDrop: "Drag and drop your file here or",
      uploadFile: "Drag 'n' drop some files here, or click to select files",
    },
    signature: {
      esign: "E-Signature(Your Name)",
    },
  },
  Wizard: {
    previous: "Previous",
    next: "Next",
    appintake: {
      personalInfo: "Patient Information",
      authorizePerson: "Authorized Person",
      insurance: "Insurance",
      medical: "Medical",
      authorization: "Authorization",
    },
    claimintake: {
      payableTo: "Payable To",
      documents: "Documents",
      signature: "Signature",
    },
  },
  Profile: {},
  Registrations: {
    reactWizard: {
      title: "Welcome to Non-Profit Patient Partner Portal Registration",
      subTatile: "Manage All Your Applications, Claims, & Cases in One Place",
      basicinfoLabel: "BASIC INFO",
      contactInfo: "CONTACT INFO",
      finishButton: "REGISTER",
      previous: "PREVIOUS",
      termsOfUse: "Terms of Use",
      termsOfUseTooltip:
        "What does Patient Advocate Foundation do with your information?",
      privacyAndCompliance: "Privacy and Compliance",
      privacyAndComplianceTooltip:
        "What does Patient Advocate Foundation do with your information?",
      programDisclaimers: "Program Disclaimers",
      programDisclaimersTooltip:
        " View the operational disclaimer and important details for each of PAF’s patient divisions.",
      portalGuide: "Portal Guide",
      portalGuideTooltip:
        "Information to help you navigate the Patient Partner Portal.",
      next: "NEXT",
      cancel: "CANCEL",
    },
    RegPopu: {
      header: "This portal is for Exempt Organization Partners only.",
      content:
        "Exempt Partners are IRS Registered 501c3 Community Organizations that are assisting patients with gaining access to quality care for their chronic and debilitating diseases. Exempt Organization Partners may include:",
      list1: "Case Managers",
      list2: "Churches and Religious Organizations",
      toRegister: "To Register:",
      toConten1:
        "You must have a valid professional email address, and an IRS Federal Tax ID Employer Identification Number",
      toContent2:
        "Once you submit your registration, you will receive an email (typically within five minutes) directing you to a website to create your password. You can then begin using our services.",
      next: "Next, ",
      toContent3: "Enter your organization information and click",
      toContent4:
        "to begin the registration process for the Patient Partner portal.",
      close: "Close",
      EIN: "EIN",
    },
    BasicInfo: {
      enterYourEIN: "Enter your Employer Identification Number (EIN) and requested information to proceed.",
      whatIsMyEIN: "What is my EIN?",
      EIN: "EIN",
      backToLogin: "Back To Login",
      needHelp: "Need Help?",
      emailAddress: "Email Address",
      personRequestingLogin: "Person Requsting Login",
      streetAddress: "Street Address",
      organizationName: "Organization Name",
      firstName: "First Name",
      lastName: "Last Name",
      PersonRequestingFirstName: "Person Requesting Login First Name",
      PersonRequestingLastName: "Person Requesting Login Last Name",
      errorMsg: "Please select or input a valid value",
      FirstNameInvalidCharacters: "First name contains invalid characters",
      LastNameInvalidCharacters: "Last name contains invalid characters",
      toastError: "Please fill all mandatory fields!",
    },
    ContactInfo: {
      edti: "Would you like to update/edit the Organization's contact information?",
      organizationName: "Organization Name:",
      fullName: "Full Name:",
      phoneNumber: "Phone No:",
      Adderss: "Address:",
      fax: "Fax No:",
      optIn: "Opt-In statement:",
      optInQustion:
        "Your Contact Information may be used in the future to share printed and/or electronic communications from Patient Advocate Foundation (PAF). If you do not wish to receive information from (PAF) click “No” to opt out.",
      note: "***NOTE: You are not required to participate in the general distribution list to use email to correspond about your services.",
      policyAgree: "Do you agree to our Terms of Use and Privacy Policy?",
      toastError: "Please fill all mandatory fields!",
      verifiedAddressToastMsg: "Please verify address",
      policyAgreeToastMsg: "User must agree to the Terms of Use and Privacy Policy",
      matchToastError: "At least 1 update is required in order to proceed",
    },
    providerForm: {
      verifyAddressError:
        "Please ensure that you have entered a valid address. We are unable to verify the address entered; however, if the address you provided is correct, please proceed.",
      verifyAddressSucces: "Address Verified.",
      verifyAdreesBtn: "Verify Address",
      organizationName: "Organization Name",
      phoneNumber: "Phone Number",
      fax: "Fax Number",
      city: "City",
      fax: "Fax Number",
      state: "State",
      zipcode: "Zip Code",
      Adderss: "Address",
      toastError: "Please fill all mandatory fields!",
      errorMsg: "Please select or input a valid value",
    },
    successful: {
      successText: "Your account has been successfully created.",
      content:
        "Please check your email for instructions to complete your registration.",
      backToLogin: "Back To Login",
    },
  },

  resetPasswordSuccess: {
    passwordResetSuccessful: "Password Reset Successful.",
    content: " Your password reset link has been sent to your registered email address.",
    please: "Please",
    ClickHere: "Click here",
    toLogin: "to login"
  },
  updatePassword: {
    wellcomeMsg: "Welcome to the Patient Partner Portal, please set your password",
    passwordRequrdMsg: "Password Requirements",
    passwordInstructions1: "Cannot contain the user's account name.",
    passwordInstructions2: "Must be at least eight characters in length.",
    passwordInstructions3: "Contain characters from the following four categories:",
    condiction1: "English uppercase characters(A-Z)",
    condiction2: "English lowercase characters(a-z)",
    condiction3: "Numeric digit(0 through 9)",
    condiction4: "Non-alphabetic characters(for example:!,$,#,%...)",
    toastErrorMsg: "Password must be minimum 8 characters, at least one number, one special character, one uppercase character and one lowercase character",
    notMatchTostMsg: "Password doesn't match",
    toastError: "Please fill all mandatory fields!",
    password: "Password",
    confirmPassword: "Confirm Password",
    updatePassword: "Update Password",
    errorMsg: "Please input a valid value",
    inValidPasswordError: "Password must be a  Minimum 8 characters,at least one number  , one special character , one uppercase characters and one lowercase characters"

  },
  passwordSuccess: {
    passwordUpdateSuccessfully: "Password  Updated Successfully",
    yourPasswordUpdate: "Your password has been updated successfully.",
    backToLogin: "Back To Login"
  },
  ForgetPassword: {
    toastError: "Enter valid email address",
    title: "Forgot Password",
    content: " Please enter your email address below and click the Reset Password button",
    emailAddress: "Email Address",
    resetPassword: "Reset Password",
    errorMsg: "Please input a valid value",
    backToRegister: "Back to Register",
    backToLogin: "Back To Login"
  }

};

export const Spanish = {
  SignUp: {},
  Login: {
    mainContent: "Unos cuantos clics más para iniciar sesión en su cuenta.",
    subContent: "Administre todas sus aplicaciones y casos en un solo lugar",
    signIn: "Iniciar sesión",
    rememberMe: "Acuérdate de mí",
    forgotPassword: "Has olvidado tu contraseña?",
    login: "Acceso",
    register: "Registro",
    agree: "Al registrarse, usted acepta nuestro",
    termsAndConditions: "Términos y condiciones",
    privacyPolicy: "política de privacidad",
    needHelp: "Necesitas ayuda?",
    tooltip0001: "Acuerdo Legal sobre los Términos de uso de nuestro portal.",
    tooltip0002: "Condiciones de uso",
    tooltip0101:
      "¿Qué hace la Fundación Defensora del Paciente con su información?",
    tooltip0102: "Privacidad y cumplimiento",
    tooltip0201:
      "Vea el descargo de responsabilidad operativo y los detalles importantes de cada una de las divisiones de pacientes de PAF.",
    tooltip0202: "Descargos de responsabilidad del programa",
    tooltip0301:
      "Información para ayudarle a navegar por el Portal de socios para pacientes.",
    tooltip0302: "Guía del portal",
  },
  Sidemenu: {
    dashboard: "Panel",
    applications: "Aplicaciones",
    cases: "Casos",
    patientSearch: "Búsqueda de pacientes",
    claims: "Reclamos",
    createApp: "Crear aplicaciones/casos",
    profile: "Perfil",
    logout: "Cerrar sesión",
  },
  Topbar: {
    heading: "Sylvester Stallone",
    subHeading: "Ingeniero DevOps",
    profile: "Perfil",
    addAccount: "Añadir cuenta",
    resetPassword: "Restablecer la contraseña",
    help: "Ayuda",
    logout: "Cerrar sesión",
  },
  ApplicationCard: {
    viewApplication: "Ver solicitud",
    patientBalance: "Saldo del paciente",
    fund: "Fondo",
    lookBackDate: "mirar hacia atrás fecha",
    approvalDate: "Fecha de aprobación",
    expiryDate: "Fecha de caducidad",
  },
  CaseCard: {
    viewCase: "Ver caso",
    program: "Programa",
    phoneNumber: "Número de teléfono",
    createdDate: "Fecha de creación",
    approvalDate: "Fecha de aprobación",
    expiryDate: "Fecha de caducidad",
  },
  Dashboard: {
    recentlyCreatedApplication: "Aplicación creada recientemente",
    casesChart: {
      cases: "Casos",
      inProgress: "En curso",
      closed: "Cerrado",
      new: "Nuevo",
      viewAll: "Ver todo",
    },
    applicationsChart: {
      application: "Solicitud",
      activeUsers: "Usuarios activos",
      approved: "Aprobado",
      expired: "Caducado",
      pending: "Pendiente",
      viewAll: "Ver todo",
    },
    resources: {
      financialResource: "Recurso Financiero",
      clickHere: "haga clic aquí",
      educationalResource: "Recurso Educativo",
    },
    requiredActions: {
      heading: "Acciones requeridas",
      showAll: "Mostrar todo",
      program: "PROGRAMA",
      description: "DESCRIPCIÓN",
      patientName: "NOMBRE DEL PACIENTE",
      status: "ESTADO",
      actions: "COMPORTAMIENTO",
      view: "vista",
    },
  },
  Messages: {
    portalMessage: "Mensaje del portal",
    recentActivities: {
      heading: "Actividades recientes",
      showMore: "Mostrar más",
    },
  },
  Applications: {
    heading: "Lista de todas las aplicaciones en su cuenta",
  },
  Cases: {
    heading: "Lista de todos los casos en su cuenta",
  },
  PatientSearch: {
    searchPatient: {
      heading: "Búsqueda de pacientes",
      subHeading:
        "Para comenzar, seleccione el programa e ingrese los detalles requeridos del paciente.",
      program: "Programa",
      patientDetails: "Detalles del paciente",
      firstName: "Nombre de pila",
      lastName: "Apellido",
      contactID: "Identificación de contacto",
      SSNorAlienNumber: "SSN o número de extranjero",
      DOB: "Fecha de nacimiento",
      search: "Buscar",
    },
    patientDetails: {
      heading: "Detalles del paciente",
      contactID: "Identificación de contacto",
      SSN: "número de seguro social",
      DOB: "Fecha de nacimiento",
      contactDetails: "Detalles de contacto",
    },
    patientCard: {
      application: "Solicitud",
      claims: "Reclamos",
      applicationID: "ID DE APLICACIÓN",
      fund: "FONDO",
      status: "ESTADO",
      actions: "COMPORTAMIENTO",
      view: "vista",
    },
  },
  Claims: {
    heading: " Lista de todos los reclamos en su cuenta",
    createExpenditure: "Crear gasto",
    program: "Programa",
    claimID: "ID DE RECLAMACIÓN",
    patientName: "NOMBRE DEL PACIENTE",
    status: "ESTADO",
    actions: "COMPORTAMIENTO",
    view: "vista",
  },
  CreateApp: {
    createApplication: "Crear aplicación",
  },
  PreQual: {
    heading: "Precalificación",
    subHeading: "Para comenzar, ingrese los detalles requeridos del paciente.",
    addressInformation: {
      heading: "DATOS DEL DOMICILIO",
      addressLine1: "Dirección Línea 1",
      addressLine2: "Línea de dirección 2",
      city: "Ciudad",
      state: "Estado",
      zipcode: "Código postal",
      verifyAddress: "Verifica la dirección",
    },
    medicalInformation: {
      heading: "INFORMACIÓN MÉDICA",
      diagnosis: "Diagnóstico",
      insurance: "¿Tiene el paciente seguro médico y/o recetado?",
      insuranceType: "Tipo de seguro",
      fund: "Fondo",
    },
    cancel: "Cancelar",
    submit: "Entregar",
  },
  AppintakeCard: {
    newPatient: "Nuevo paciente",
    DOB: "Fecha de nacimiento",
    SSNorAlienNumber: "SSN o número de extranjero",
    phoneNumber: "Número de teléfono",
    email: "Correo electrónico",
  },
  Appintake: {
    personalInformation: {
      addressInformation: {
        heading: "DATOS DEL DOMICILIO",
        addressType: "Tipo de dirección",
        addressLine1: "Dirección Línea 1",
        addressLine2: "Línea de dirección 2",
        city: "Ciudad",
        state: "Estado",
        zipcode: "Código postal",
      },
      contactDetails: {
        heading: "DETALLES DE CONTACTO",
        contactBy:
          "¿Cómo le gustaría que le contactáramos? Todas las cartas y comunicaciones del programa se le enviarán según su selección.",
        preferedLanguage: "Idioma preferido",
        email: "Correo electrónico",
        emailType: "Tipo de correo electrónico",
        phoneType: "Tipo de telefono",
        phoneNumber: "Número de teléfono",
        contactSequence: "Secuencia de contacto",
      },
      guardianInfo: {
        heading: "Información del tutor",
        guardianFirstName: "Nombre del tutor",
        guardianLastName: "Apellido del tutor",
        suffix: "Sufijo",
        guardianDOB: "Fecha de nacimiento del tutor",
        guardianSSN: "SSN del tutor o número de extranjero",
        relationshipToPatient: "Relación con el paciente",
        guardianEmployment: "Estado laboral del tutor",
        guardianEmail: "Correo electrónico del tutor",
        emailType: "Tipo de correo electrónico",
        sameAddress: "Misma dirección que el paciente",
        samePhoneNumber: "Mismo número de teléfono que el paciente",
        addressLine1: "Dirección Línea 1",
        addressLine2: "Línea de dirección 2",
        city: "Ciudad",
        state: "Estado",
        zipcode: "Código postal",
        verifyAddress: "Verifica la dirección",
        phoneType: "Tipo de telefono",
        phoneNumber: "Número de teléfono",
      },
      additionalInformation: {
        heading: "INFORMACIÓN ADICIONAL",
        gender: "Género",
        employementStatus: "situación laboral",
        veteran: "Veterano",
        maritalStatus: "Estado civil",
        householdSize: "Tamaño del hogar",
      },
      race: {
        heading: "Carrera",
        americanIndian: "Indio americano / nativo de Alaska",
        asian: "Asiático",
        africanAmerican: "Negro / afroamericano",
        white: "Blanco",
        pacificIslander: "Nativo hawaiano / isleño del Pacífico",
        preferNotToDisclose: "Prefiero no revelar",
        Origin: "Origen hispano/latino/español",
      },
      applicantInformation: {
        heading: "INFORMACIÓN DEL APLICANTE",
        relationshipToPatient: "Relación con el paciente",
      },
      referalInformation: {
        heading: "INFORMACIÓN DE REFERENCIA",
        referredBy: "¿Cómo fue remitido el paciente al programa?",
      },
    },
    authorizedPerson: {
      authorizedPersonInfo:
        "La información del paciente solo se discutirá o divulgará según sea necesario para ayudar en la determinación y prestación de servicios del Programa al que el paciente se postula. Cualquier solicitud para compartir información con cualquier persona que no sea el equipo médico del paciente solo podrá realizarse con el consentimiento expreso del paciente. Enumere todas las personas (que no sean el equipo de atención médica del paciente) que el paciente ha autorizado a comunicarse con el programa en su nombre. (Los ejemplos incluyen, entre otros, cónyuge, pareja, padre, hijo, hermano, trabajador social, administrador de casos, amigo, etc.).",
      authorizedPersonQuestion:
        "¿Hay usuarios autorizados que puedan hablar en nombre del paciente?",
      firstName: "Nombre de pila",
      lastName: "Apellido",
      suffix: "Sufijo",
      relationshipToPatient: "Relacion con el paciente",
      sameAddress: "¿La misma dirección que el paciente?",
      samePhoneNumber: "¿El mismo número de teléfono que el paciente?",
      addressLine1: "Dirección Línea 1",
      addressLine2: "Línea de dirección 2",
      city: "Ciudad",
      state: "Estado",
      zipcode: "Código postal",
      verifyAddress: "Verifica la dirección",
      phoneType: "Tipo de telefono",
      phoneNumber: "Número de teléfono",
      addOneMore: "AGREGA UNA MÁS",
    },
    insurance: {
      primaryInsurancecarrier: "ASEGURADOR PRIMARIO",
      healthInsurance: "¿Tiene el paciente seguro médico?",
      policyDetails: {
        heading: "DETALLES DE LA POLÍTICA",
        primaryInsurance: "Seguro Primario",
        planType: "Tipo de plan",
        policyID: "ID de política",
        insuranceType: "Tipo de seguro",
        telephoneNumber: "Número de teléfono del seguro primario",
      },
      subscriberDetails: {
        heading: "DETALLES DEL SUSCRIPTOR",
        subscriberName: "Nombre del suscriptor",
        groupNumber: "Número de grupo",
        DOB: "Fecha de nacimiento del suscriptor (MM/DD/AAAA)",
      },
      insuranceInformation: {
        heading: "INFORMACIÓN DEL SEGURO",
        medicareSupplement: "¿El paciente tiene un suplemento de Medicare?",
        secondaryInsurance: "¿El paciente tiene seguro secundario?",
        medicarePart: "¿Tiene Medicare Parte D?",
        secondaryInsuranceCarrier: "Nombre de la compañía de seguros",
      },
    },
    medical: {
      searchTreatingPhysician: "Busque a su médico tratante",
      stateandCity:
        "Ingrese el estado y la ciudad para buscar a su médico tratante.",
      additionalInfo:
        "Ingrese información adicional para mejorar los resultados de su búsqueda.",
      state: "Estado",
      city: "Ciudad",
      firstName: "Nombre de pila",
      lastName: "Apellido",
      zipcode: "Código postal",
      reset: "Reiniciar",
      search: "Buscar",
      address: "DIRECCIÓN",
      primaryDiagnosis: "Diagnóstico primario del paciente",
      DOD: "Datos de diagnóstico",
    },
  },
  Claimintake: {
    payableTo: {
      heading: "A nombre de",
      name: "Nombre",
      addressLine1: "Dirección Línea 1",
      addressLine2: "Línea de dirección 2",
      city: "Ciudad",
      state: "Estado",
      zipcode: "Código postal",
      verifyAddress: "Verifica la dirección",
    },
    documents: {
      dragAndDrop: "Arrastre y suelte su archivo aquí o",
      uploadFile: "Cargar un archivo",
    },
    signature: {
      esign: "Firma electrónica (su nombre)",
    },
  },
  Wizard: {
    previous: "Previo",
    next: "Próximo",
    appintake: {
      personalInfo: "Información personal",
      authorizePerson: "Persona autorizada",
      insurance: "Seguro",
      medical: "Médico",
      authorization: "Autorización",
    },
    claimintake: {
      payableTo: "A nombre de",
      documents: "Documentos",
      signature: "Firma",
    },
  },
  Profile: {},
  Registrations: {
    reactWizard: {
      title: "Bienvenido al Registro en el Portal de Socios de Pacientes",
      subTatile:
        "Gestione todas sus solicitudes, reclamaciones y casos en un solo lugar",
      basicinfoLabel: "INFORMACIÓN BÁSICA",
      contactInfo: "INFORMACIÓN DE CONTACTO",
      finishButton: "REGISTRO",
      previous: "ANTERIOR",
      termsOfUse: "Condiciones de uso",
      termsOfUseTooltip:
        "¿Qué hace la Fundación del Defensor del Paciente con su información?",
      privacyAndCompliance: "Privacidad y cumplimiento",
      privacyAndComplianceTooltip:
        "¿Qué hace la Fundación del Defensor del Paciente con su información?",
      programDisclaimers: "Descargos de responsabilidad del programa",
      programDisclaimersTooltip:
        "Consulte el descargo de responsabilidad operativo y los detalles importantes de cada una de las divisiones de pacientes de PAF.",
      portalGuide: "Guía del portal",
      portalGuideTooltip:
        "Información que le ayudará a navegar por el Portal de Socios Pacientes.",
      next: "PRÓXIMA",
      cancel: "CANCELAR",
    },
    RegPopu: {
      header: "Este portal es solo para socias de organizaciones exentas.",
      content:
        "Los socios exentos son organizaciones comunitarias 501c3 registradas por el IRS que ayudan a los pacientes a obtener acceso a atención de calidad para sus enfermedades crónicas y debilitantes. Los socios de organizaciones exentas pueden incluir:",
      list1: "Administradores de casos",
      list2: "Iglesias y organizaciones religiosas",
      toRegister: "Para registrarse:",
      toConten1:
        "Debe tener una dirección de correo electrónico profesional válida y un número de identificación de empleador de identificación fiscal federal del IRS",
      toContent2:
        "Una vez que envíe su registro, recibirá un correo electrónico (generalmente dentro de los cinco minutos) que lo dirigirá a un sitio web para crear su contraseña. A continuación, puede comenzar a utilizar nuestros servicios.",
      next: "PRÓXIMA",
      toContent3: "Enter your organization information and click",
      toContent4:
        "to begin the registration process for the Patient Partner portal.",
      close: "Cerrar",
      EIN: "EIN",
    },
    BasicInfo: {
      enterYourEIN: "Ingrese su EIN y la información solicitada para continuar.",
      whatIsMyEIN: "¿Cuál es mi EIN?",
      EIN: "EIN",
      backToLogin: "Volver al inicio de sesión",
      needHelp: "¿Necesita ayuda?",
      emailAddress: "Dirección de correo electrónico",
      personRequestingLogin: "Persona que solicita iniciar sesión",
      streetAddress: "Dirección de la calle",
      organizationName: "Nombre de la organización",
      errorMsg: "Seleccione o introduzca un valor válido",
    },
    ContactInfo: {
      edti: "¿Desea actualizar/editar la información de contacto de la proveedora de atención médica?",
      organizationName: "Nombre de la organización:",
      phoneNumber: "Nº de teléfono:",
      Adderss: "Dirección:",
      fax: "Fax:",
      optIn: "Declaración de inclusión:",
      optInQustion: `Su información de contacto puede ser utilizada en el futuro para compartir comunicaciones impresas y/o electrónicas de la Fundación del Defensor del Paciente (PAF). Si no desea recibir información de (PAF), haga clic en "No" para darse de baja.`,
      note: "***NOTE: You are not required to participate in the general distribution list to use email to correspond about your services.",
      policyAgree:
        "¿Está de acuerdo con nuestros Términos de uso y Política de privacidad?",
      toastError: "¡Por favor, rellene todos los campos obligatorios!",
      verifiedAddressToastMsg: "Verifique la dirección del paciente",
      policyAgreeToastMsg: "¡Por favor, acepte los términos y condiciones!",
      matchToastError: "Se requiere al menos 1 actualización para continuar",
    },
    providerForm: {
      verifyAddressError:
        "Asegúrese de haber introducido una dirección válida. No podemos verificar la dirección ingresada; Sin embargo, si la dirección que proporcionó es correcta, continúe.",
      verifyAdreesBtn: "Verificar dirección",
      organizationName: "Nombre de la organización",
      phoneNumber: "Número de teléfono",
      fax: "Número de fax",
      city: "Ciudad",
      state: "Estado",
      zipcode: "Código Postal",
      Adderss: "Dirección",
      toastError: "¡Por favor, rellene todos los campos obligatorios!",
      errorMsg: "Seleccione o introduzca un valor válido",
    },
    successful: {
      successText: "Your account has been successfully created.",
      content:
        "Please check your email for instructions to complete your registration.",
      backToLogin: "Back To Login",
    },
  },
  resetpasswordSuccess: {
    passwordResetSuccessful: "Password Reset Successful.",
    content: " Your password reset link has been sent to your registered email address.",
    please: "Please",
    ClickHere: "Click here",
    toLogin: "to login"
  },
  updatePassword: {
    wellcomeMsg: "Welcome to the Patient Partner Portal, please set your password",
    passwordRequrdMsg: "Password Requirements",
    passwordInstructions1: "Cannot contain the user's account name.",
    passwordInstructions2: "Must be at least eight characters in length.",
    passwordInstructions3: "Contain characters from the following four categories:",
    condiction1: "-English uppercase characters(A-Z)",
    condiction2: "-English lowercase characters(a-z)",
    condiction3: "-Numeric digit(0 through 9)",
    condiction4: "--Non-alphabetic characters(for example:!,$,#,%...)",
    toastErrorMsg: "Password must be minimum 8 characters, at least one number, one special character, one uppercase character and one lowercase character",
    notMatchTostMsg: "Password doesn't match",
    password: "Password",
    confirmPassword: "Confirm Password",
    toastError: "Please fill all mandatory fields!",
    updatePassword: "Update Password",
    errorMsg: "Please input a valid value",
    inValidPasswordError: "Password must be a  Minimum 8 characters,at least one number  , one special character , one uppercase characters and one lowercase characters"

  },
  passwordSuccess: {
    passwordUpdateSuccessfully: "Password  Updated Successfully",
    yourPasswordUpdate: "Your password has been updated successfully.",
    backToLogin: "Back To Login"
  },
  ForgetPassword: {
    toastError: "Enter valid email address",
    title: "Forgot Password",
    content: " Please enter your email address below and click the Reset Password button",
    emailAddress: "Email Address",
    resetPassword: "Reset Password",
    errorMsg: "Please input a valid value",
    backToRegister: "Back to Register",
    backToLogin: "Back To Login"
  }
};
